import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class EventPageBlockTypeService {

  public list = [
    { id: 1, label: "Text", value: 0 },
    { id: 2, label: "FAQ", value: 1 },
    { id: 3, label: "Slides", value: 2 },
    { id: 4, label: "Campaign", value: 3 },
    { id: 5, label: "Silent auction campaign", value: 4 },
    { id: 6, label: "Live auction campaign", value: 5 },
    { id: 7, label: "Video Container", value: 6 },
    { id: 8, label: "Event Page Image", value: 7 }
  ];

  constructor() { }
}
